import { StreamChat } from 'stream-chat'

const streamChatClient = StreamChat.getInstance(
  process.env.REACT_APP_STREAM_CHAT_KEY!,
  {
    timeout: 20_000,
    timeoutErrorMessage: 'Chat timeout after 20 seconds',
  }
)

export { streamChatClient }
